const e = {
  extends: "PowerBall",
  style: {
    extraBall: {
      bg: "#e31d1a"
    }
  }
};
export {
  e as default
};
